import { useState, useEffect, useRef, ChangeEvent } from 'react'
import { SAME } from 'apps/carrier/constants/insurance'

function usePrevious(value: string) {
  const ref = useRef()
  useEffect(() => {
    // @ts-ignore
    ref.current = value
  }, [value])
  return ref.current
}

export interface IDefaultValue {
  phone?: string
  fax?: string
  email?: string
}

export type DefaultKey = 'phone' | 'fax' | 'email'

const useFallback = (
  id: string,
  value: string,
  onChange: (...args: any[]) => any,
  defaults: IDefaultValue,
  key: DefaultKey
) => {
  const canFallback = !!defaults
  const [fallback, setFallback] = useState(canFallback)
  const prevValue = usePrevious(value)

  useEffect(() => {
    if (canFallback && fallback) {
      onChange({ target: { id, value: defaults[key] } })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaults && defaults[key], fallback])

  useEffect(() => {
    if (canFallback && !prevValue) {
      const sameAsFallback = value === (defaults || {})[key]
      if (sameAsFallback) {
        setFallback(true)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [canFallback, value])

  const changeFallback = ({ target: { value: newFallback } }: ChangeEvent<HTMLInputElement>) => {
    setFallback(newFallback === SAME)
  }

  return [canFallback, fallback, changeFallback]
}

export default useFallback
